/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo, useState } from "react";

// CSS読み込み
import {
  labelWithHintWrap,
  labelWithHintImg,
  labelWithHintText,
  modalWrap,
  modalWrap_hidden,
  modalContents,
  closeImg,
} from "assets/css/stylesCss";

import {
  none,
} from "assets/css/shchMtmr";

const hintSmall = require("assets/img/hint/badgeUI-hint_small.png");
const hintMedium = require("assets/img/hint/badgeUI-hint_small@2x.png");
const hintLarge = require("assets/img/hint/badgeUI-hint_small@3x.png");

const closeSmall = require("assets/img/close/ico-close.png");
const closeMedium = require("assets/img/close/ico-close@2x.png");
const closeLarge = require("assets/img/close/ico-close@3x.png");

/**
 * ヒント付きラベルコンポーネント
 * @param {String} title タイトル
 * @param {Boolean} isShow ヒントを表示するか※isShowは画像添付されているかを持つ
 *                  true : ヒントを表示
 *                  false: ヒントを表示しない
 * @param {String} children 子要素
 */
const labelWithHint = memo(({ title, isShow, children }) => {

  // モーダルを開いているかどうか
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      {/* ラベル */}
      <div css={[labelWithHintWrap, isShow ? "" : none]}>
        <label css={labelWithHintText} onClick={() => setIsOpenModal(true)}>
          {title}
        </label>
        <img
          css={labelWithHintImg}
          src={hintSmall}
          srcSet={`${hintSmall} 1x, ${hintMedium} 2x, ${hintLarge} 3x`}
          alt="ヒントアイコン"
          onClick={() => setIsOpenModal(true)}
        />
      </div>
      {/* モーダル */}
      <div
        css={isOpenModal ? modalWrap : modalWrap_hidden}
        onClick={() => setIsOpenModal(false)}
      >
        {/* 親要素のonClick処理を中断 */}
        <div css={modalContents} onClick={(e) => e.stopPropagation()}>
          {children}
          <img
            css={closeImg}
            onClick={() => setIsOpenModal(false)}
            src={closeSmall}
            srcSet={`${closeSmall} 1x, ${closeMedium} 2x, ${closeLarge} 3x`}
            alt="閉じるアイコン"
          />
        </div>
      </div>
    </>
  );
});

export default labelWithHint;
